module.exports = __webpack_public_path__ + "static/media/right-img@3x.88a3fd16.png";